<template>
  <div>
    <b-row>
      <b-col>
        <h2>
          <i class="fa fa-fw fa-boxes"></i>
          {{ trans('categories') }}
        </h2>
      </b-col>
      <b-col class="col-auto text-right pt-1">
        <b-button size="sm" variant="secondary" @click="onRefresh" :title="trans('refresh')" :disabled="busy" v-b-tooltip.hover>
          <i class="fa fa-fw fa-redo" v-if="!busy"></i>
          <i class="fa fa-fw fa-circle-notch fa-spin" v-if="busy"></i>
        </b-button>
        <b-button size="sm" variant="secondary" class="ml-2" :title="trans('reorder_items')" :disabled="busy" v-b-tooltip.hover v-b-modal.reorder-categories-modal>
          <i class="fa fa-fw fa-bars"></i>
        </b-button>
        <reorder-modal
          id="reorder-categories-modal"
          :get-url="`/organization/${organization.id}/package_category/list?per_page=100`"
          :save-url="`/organization/${organization.id}/package_category/reorder`"
          @saved="onReordered"
        ></reorder-modal>
        <b-button size="sm" variant="primary" @click="onAdd" class="ml-2">
          <i class="fa fa-fw fa-plus"></i>
        </b-button>
        <a v-if="!hideMicrositeButton" :href="`/org/${organization.id}`" target="microsite" class="btn btn-sm btn-branded ml-2">
          {{ trans('microsite') }}
          <i class="fa fa-fw fa-external-link-alt"></i>
        </a>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          id="package_categories"
          ref="table"
          class="bg-white table-row-click"
          bordered
          small
          responsive
          show-empty
          :fields="fields"
          :items="provider"
          :per-page="perPage"
          :current-page="currentPage"
          @row-clicked="onRowClick"
        >
          <template v-slot:empty>
            <p align="center">{{ trans('no_package_category_found') }}</p>
          </template>
          <template v-slot:cell(action)="data">
            <a :href="`/org/${organization.id}/packages/${data.item.id}`" target="_microsite" class="text-muted">
              <i class="fa fa-fw fa-external-link-alt"></i>
            </a>
          </template>
          <template v-slot:cell(visible)="data">
            <visible-switch
              v-model="data.item.visible"
              :save-url="`/organization/${organization.id}/package_category/${data.item.id}/visible`"
              :disabled="busy"
              @input="onVisibleChanged"
            />
          </template>
        </b-table>
        <b-pagination
          :per-page="perPage"
          :current-page="currentPage"
          :total-rows="totalRows"
          v-model="currentPage"
          aria-controls="package_categories"
          align="center"
        />
      </b-col>
    </b-row>
    <package-category-modal
      :organization="organization"
      :package_category="package_category"
      @saved="onSaved"
      @deleted="onDeleted"
    ></package-category-modal>
  </div>
</template>

<script>
  import PackageCategoryModal from './PackageCategoryModal'
  import ReorderModal from './../../../common/components/ReorderModal'
  import VisibleSwitch from './../../../common/components/VisibleSwitch'

  export default {
    props: {
      organization: Object,
      hideMicrositeButton: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      PackageCategoryModal,
      ReorderModal,
      VisibleSwitch,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        busy: false,
        error: null,
        fields: [
          {key: 'name', label: trans('name')},
          {
            key: 'updated_at',
            label: trans('last_updated'),
            formatter(value, key, item) {
              return moment(value).format('LLL')
            },
          },
          {key: 'visible', label: trans('visible')},
          {key: 'action', label: ''},
        ],
        items: [],
        perPage: 10,
        currentPage: 1,
        totalRows: 0,
        package_category: null,
      }
    },
    methods: {
      onSaved() {
        this.$emit('changed')
        this.$refs.table.refresh()
      },
      onDeleted() {
        this.$emit('changed')
        this.$refs.table.refresh()
      },
      onReordered() {
        this.$emit('changed')
        this.$refs.table.refresh()
      },
      onVisibleChanged() {
        this.$emit('changed')
      },
      onRefresh() {
        this.$refs.table.refresh()
      },
      onAdd() {
        this.package_category = undefined
        this.$nextTick(() => {
          this.$bvModal.show('package-category-modal')
        })
      },
      onRowClick(package_category) {
        this.package_category = package_category
        this.$nextTick(() => {
          this.$bvModal.show('package-category-modal')
        })
      },
      provider() {
        this.error = null
        this.busy = true
        let url = `/organization/${this.organization.id}/package_category/list?page=${this.currentPage}&per_page=${this.perPage}`
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.currentPage = response.data.current_page
          this.perPage = response.data.per_page
          this.totalRows = response.data.total
          this.items = response.data.data
          return this.items
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          _.toastError(this, this.error)
          this.items = []
          return this.items
        })
      },
    },
  }
</script>